@if (identification) {
<dl>
  <dd>{{ 'payment.identification.classifier.' + identification | translate: locale.language }}</dd>
  @if (displayIdentificationType) {
  <dt translate>payment.identification.type.label</dt>
  <dd>
    @if (!identificationDocument) {
    <span> {{ 'payment.identification.classifier.' + identificationType | translate: locale.language }} </span>
    } @if (identificationCodeType) {
    <span> - {{ identificationCodeType | partyIdentificationCodeType: identification }} </span>
    } @if (identificationDocument) {
    <span> {{ identificationDocument | partyIdentificationDocument }} </span>
    }
  </dd>
  } @if (displayIdentificationCodeTypeOnly) {
  <hr class="identification-separator" />
  <dt translate>payment.identification.type.label</dt>
  <dd>
    <span>{{ identificationCodeType | partyIdentificationCodeType: identification }}</span>
  </dd>
  } @if (identificationCode) {
  <dl>
    <dt translate>payment.receiverInfo.beneficiaryIdentificationCode.label</dt>
    <dd>
      <span>{{ identificationCode }}</span>
    </dd>
  </dl>
  }
</dl>
} @if (id) {
<dl>
  <dt translate>payment.identification.id.label</dt>
  <dd>{{ id }}</dd>
</dl>
} @if (identificationIssueCountry) {
<dl>
  <dt translate>payment.identification.issueCountry.label</dt>
  <dd>{{ identificationIssueCountry | country }}</dd>
</dl>
} @if (identificationIssueDate) {
<dl>
  <dt translate>payment.identification.issueDate.label</dt>
  <dd>{{ identificationIssueDate | appDate: locale.language }}</dd>
</dl>
} @if (identificationExpiryDate) {
<dl>
  <dt translate>payment.identification.expiryDate.label</dt>
  <dd>{{ identificationExpiryDate | appDate: locale.language }}</dd>
</dl>
} @if (identificationLegalEntityIdentifier) {
<hr class="identification-separator" />
<dl>
  <dt translate>payment.identification.type.label</dt>
  <dd>
    <span>{{ IdentificationCodeType.LEI | partyIdentificationCodeType: identification }}</span>
  </dd>
</dl>
<dl>
  <dt translate>payment.identification.id.label</dt>
  <dd>
    <span>{{ identificationLegalEntityIdentifier }}</span>
  </dd>
</dl>
} @if (identificationBic) {
<hr class="identification-separator" />
<dl>
  <dt translate>payment.identification.type.label</dt>
  <dd>
    <span translate>payment.beneficiaryBankIdentifier.label</span>
  </dd>
</dl>
<dl>
  <dt translate>payment.identification.id.label</dt>
  <dd>
    <span>{{ identificationBic }}</span>
  </dd>
</dl>
} @if (identificationName) {
<dl>
  @if (identification === PartyIdentificationType.PRIVATE) {
  <dt translate>reg.details.personGivenName.label</dt>
  } @if (identification === PartyIdentificationType.ORGANISATION) {
  <dt translate>settings.profileSettings.profile-information.companyName</dt>
  }
  <dd>{{ identificationName }}</dd>
</dl>
} @if (identificationSurname) {
<dl>
  <dt translate>reg.details.personSurname.label</dt>
  <dd>{{ identificationSurname }}</dd>
</dl>
} @if (birthDate && identificationType) {
<dl>
  <dt translate>payment.identification.birthDate.label</dt>
  <dd>{{ birthDate | appDate: locale.language }}</dd>
</dl>
} @if (countryOfBirth) {
<dl>
  <dt translate>payment.identification.countryOfBirth.label</dt>
  <dd>{{ countryOfBirth | country }}</dd>
</dl>
} @if (provinceOfBirth) {
<dl>
  <dt translate>payment.identification.provinceOfBirth.label</dt>
  <dd>{{ provinceOfBirth }}</dd>
</dl>
} @if (cityOfBirth) {
<dl>
  <dt translate>payment.identification.cityOfBirth.label</dt>
  <dd>{{ cityOfBirth }}</dd>
</dl>
}
